import { render, staticRenderFns } from "./TheAuthRegister.vue?vue&type=template&id=93437c3c&"
import script from "./TheAuthRegister.vue?vue&type=script&lang=js&"
export * from "./TheAuthRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports